/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".gallery-filters[_ngcontent-%COMP%]{display:-webkit-box;display:flex}"];
export { styles as styles };
